import { render, staticRenderFns } from "./MedecinDetailPupilleedit.vue?vue&type=template&id=c1ce919e&"
import script from "./MedecinDetailPupilleedit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailPupilleedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports